module.exports = __webpack_public_path__ + "static/logo-NDA-napis-969f228b390ab285978322a8d7fb85b8.webp";